import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { toast } from "../../components/AppToast";
import StockTransferOutList from "./StockTransferOutList";
import AddStockTransferOut from "./AddStockTransferOut";
import {
  extractStockTransferOutId,
  getStockTransferOutById,
} from "../../services/stockTransferOut/stockTransferOut";

export default function StockTransferOutManagement() {
  const [isCreating, setIsCreating] = useState(false);
  const [viewDoc, setViewDoc] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const [listVersion, setListVersion] = useState(0);

  const closeSubView = () => {
    setIsCreating(false);
    setViewDoc(null);
    setViewLoading(false);
    setListVersion((v) => v + 1);
  };

  const transferLabel =
    viewDoc?.transferNo ??
    viewDoc?.transferNumber ??
    viewDoc?.stoNumber ??
    viewDoc?.reference ??
    "";

  return (
    <div className="card shadow-lg main-card">
      <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
        <h4 className="mb-0 h6 fw-semibold">
          {viewDoc
            ? "View Stock Transfer Out"
            : isCreating
              ? "Create Stock Transfer Out"
              : "Stock Transfer Out"}
        </h4>
      </div>

      {(isCreating || viewDoc || viewLoading) && (
        <nav
          aria-label="breadcrumb"
          className="px-3 py-2 border-bottom bg-light"
        >
          <ol
            className="breadcrumb mb-0 align-items-center"
            style={{ "--bs-breadcrumb-divider": "'/'" }}
          >
            <li className="breadcrumb-item">
              <button
                type="button"
                className="btn btn-link p-0 text-decoration-none text-muted"
                onClick={closeSubView}
                disabled={viewLoading}
              >
                Stock Transfer Out
              </button>
            </li>
            <li
              className="breadcrumb-item active fw-semibold text-primary"
              aria-current="page"
            >
              {viewLoading
                ? "Loading…"
                : viewDoc
                  ? transferLabel
                    ? `View ${transferLabel}`
                    : "View transfer"
                  : "Create Stock Transfer Out"}
            </li>
          </ol>
        </nav>
      )}

      <div className="card-body">
        {viewLoading ? (
          <div className="d-flex align-items-center gap-2 py-5 justify-content-center text-muted">
            <Spinner animation="border" size="sm" />
            Loading transfer…
          </div>
        ) : viewDoc ? (
          <AddStockTransferOut
            key={
              extractStockTransferOutId(viewDoc) ||
              (viewDoc?._id != null ? String(viewDoc._id) : '') ||
              'sto-view'
            }
            viewOnly
            initialDocument={viewDoc}
            onCancel={closeSubView}
          />
        ) : isCreating ? (
          <AddStockTransferOut
            onCancel={() => {
              setIsCreating(false);
              setListVersion((v) => v + 1);
            }}
          />
        ) : (
          <StockTransferOutList
            refreshKey={listVersion}
            onCreateClick={() => setIsCreating(true)}
            onView={async (row) => {
              const id =
                extractStockTransferOutId(row) ||
                String(row?.id || "").trim() ||
                String(row?._id || "").trim();
              if (!id) {
                toast.error(
                  "Cannot open this transfer: the list response has no document id (_id / id). Check the API list payload."
                );
                return;
              }
              setViewLoading(true);
              setViewDoc(null);
              try {
                const doc = await getStockTransferOutById(id);
                setViewDoc(doc);
              } catch (err) {
                const msg =
                  err?.message ||
                  err?.response?.data?.message ||
                  "Failed to load stock transfer out";
                toast.error(msg);
              } finally {
                setViewLoading(false);
              }
            }}
          />
        )}
      </div>
    </div>
  );
}
